import { InnerBox } from "@/components/elements/InnerBox";
import { DATE_FORMAT } from "@/constants/datetime";
import { MatchFileLink } from "@/features/match/components/match-info/MatchFileLink";
import { MatchInfoItem } from "@/features/match/components/match-info/MatchInfoItem";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import { CollapsibleSectionHeader, useCollapsible } from "@/features/talent/components/talent-common/CollapsibleSectionHeader";
import { divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Collapse, Grid } from "@mui/material";
import dayjs from "dayjs";

type TMatchJobIntroductionManagerInfoProps = {
  defaultValues: Partial<TMatchInfo>;
};

export const MatchJobIntroductionManagerInfo: FCC<TMatchJobIntroductionManagerInfoProps> = ({ defaultValues }) => {
  const matchOffices = defaultValues?.matchOffices || [];
  const MIN_DISPLAY_COUNT = 3;
  const MATCH_OFFICE_COUNT = Math.max(matchOffices.length, MIN_DISPLAY_COUNT);
  const { expanded, toggle } = useCollapsible();

  return (
    <InnerBox showDivider={false} padding={3} borderColor={divider.high}>
      <CollapsibleSectionHeader title="職業紹介責任者情報" expanded={expanded} onToggle={toggle} />

      <Collapse in={expanded}>
        <Grid mt={2} container columnSpacing={3} rowSpacing={1}>
          {Array.from({ length: MATCH_OFFICE_COUNT }, (_, i) => {
            const matchOffice = matchOffices[i];
            const isLastRow = i === MATCH_OFFICE_COUNT - 1;

            return (
              <Grid key={`responsible-person-${i}`} item xs={12} container columnSpacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                  <MatchInfoItem label={`${i + 1}. 事業所名`} value={matchOffice?.officeName || "-"} isShowDivider={!isLastRow} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MatchInfoItem label="氏名" value={matchOffice?.fullName || "-"} isShowDivider={!isLastRow} />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MatchInfoItem
                    label="講習受講日"
                    value={
                      matchOffice?.trainingDate && dayjs(matchOffice.trainingDate).isValid()
                        ? dayjs(matchOffice.trainingDate).format(DATE_FORMAT)
                        : null
                    }
                    isShowDivider={!isLastRow}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  {matchOffice?.appointmentNotificationFilePath ? (
                    <MatchFileLink
                      label="講習受講証明書"
                      filePath={matchOffice.appointmentNotificationFilePath}
                      isShowDivider={!isLastRow}
                    />
                  ) : (
                    <MatchInfoItem label="講習受講証明書" value="-" isShowDivider={!isLastRow} />
                  )}
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Collapse>
    </InnerBox>
  );
};
